import { render, staticRenderFns } from "./JImageUpload.vue?vue&type=template&id=099b5b00&scoped=true"
import script from "./JImageUpload.vue?vue&type=script&lang=js"
export * from "./JImageUpload.vue?vue&type=script&lang=js"
import style0 from "./JImageUpload.vue?vue&type=style&index=0&id=099b5b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b5b00",
  null
  
)

export default component.exports